export const MenuList = [
  {
    title: "HOME",
    url: "/",
  },
  {
    title: "SKILL",
    url: "/skill&tools",
  },
  {
    title: "PROJECT",
    url: "/project",
  },
  {
    title: "ABOUT",
    url: "/about",
  },
];
